import React from 'react'
import Styled from './styled'
import { useAsync } from 'react-use'
import Button from 'components/Button'
import Card from 'components/Card'
import _ from 'lodash'
import TableCorrective from 'components/TableCorrective'
import Modal from 'components/Modal'
import Input from 'components/Input'
import Select from 'components/Select'
import TextArea from 'components/TextArea'
import Upload from 'components/Upload'
import {
  Space,
  Form,
  Radio,
  Row,
  Col,
  notification,
  DatePicker,
  Tooltip,
  Modal as ModalAntd,
} from 'antd'
import { EditOutlined, SettingOutlined, DeleteOutlined } from '@ant-design/icons'
import { useTranslate } from 'hooks/translate'
import { getAllUser } from 'services/user'
import { getTaskByParams } from 'services/reportTask'
import { getDefaultDescriptionApi } from 'services/incident'
import { createTaskApi, updateTaskApi, deleteTaskApi } from 'services/reportTask'
import { getValueListByTypeCodeApi, getValueListApi } from 'services/value_list'
import {
  getReportAttachmentApi,
  postReportAttachmentApi,
  deleteReportAttachmentApi,
} from 'services/ReportAttachment'
import moment from 'moment'
export default function Task ({ taskReportHeaderId, disabled }) {
  const { t } = useTranslate()
  const [visibleModel, setVisibleModel] = React.useState(false)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [saveBtModalLoading, setSaveBtModalLoading] = React.useState(false)
  const [dropDownParent, setDropdownParent] = React.useState([])
  const [dropDownAssignee, setDropDownAssignee] = React.useState([])
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = React.useState(false)
  const [taskLoading, setTaskLoading] = React.useState(false)
  const [editingId, setEditingId] = React.useState(null)
  const [dataSource, setDataSource] = React.useState([])
  const [allUser, setAllUser] = React.useState([])
  const [dropDownPiority, setDropDownPiority] = React.useState([])
  const [dropDownStatus, setDropDownStatus] = React.useState([])
  const [reportHeaderId, setReportHeaderId] = React.useState(taskReportHeaderId)
  // const [fileList, setFileList] = React.useState([])
  const [disabledRadio, setDisabledRadio] = React.useState(false)
  const [labelName, setLabelName] = React.useState(t('ชื่อแผนงาน'))
  const [disabledParentDd, setDisabledParentDd] = React.useState(false)
  const [disabledStartDate, setDisabledStartDate] = React.useState(false)
  const [disabledAssginee, setDisabledAssginee] = React.useState(false)
  const [defaultDescription, setDefaultDescription] = React.useState('')
  const is_riskAnalyst = JSON.parse(localStorage.getItem('user'))?.profile?.role_id === 4

  let fileList = []

  React.useEffect(() => {
    if (dataSource) {
      setDataSource(dataSource)
    }
  }, [dataSource])

  const columns = [
    {
      title: t('Corrective Action'),
      dataIndex: 'corrective_action',
      key: 'corrective_action',
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee',
      key: 'assignee',
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
    },
    {
      title: t('Due Date'),
      dataIndex: 'task_due_date',
      key: 'task_due_date',
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      render: (text, record, index) => {
        if (record.is_edit == 0) {
          return
        }
        return (
          <Space size='small'>
            <Tooltip title={t('Create')}>
              <Button
                type='link'
                icon={<EditOutlined />}
                disabled={disabled}
                onClick={() => {
                  setLabelName(t('ชื่อแผนงาน'))
                  let dateNow = new Date()

                  form.resetFields()
                  form.setFieldsValue({
                    parent_id: record?.report_task_id,
                    task_assignee_id: record?.task_assignee_id,
                    task_priority_id: record?.task_priority_id,
                    task_desc: defaultDescription,
                    start_date: moment(
                      `${dateNow.getFullYear()}-${dateNow.getMonth() + 1}-${dateNow.getDate()}`
                    ),
                  })
                  setDisabledParentDd(true)
                  setDisabledStartDate(true)
                  setDisabledAssginee(true)
                  setEditingId(null)
                  setRadioGroup()
                  showModal()
                }}
              />
            </Tooltip>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                icon={<SettingOutlined />}
                disabled={is_riskAnalyst ? false : disabled}
                onClick={async () => {
                  setEditingId(record.key)
                  setLabelName(t('ชื่อแผนงาน'))
                  const files = await getFile(record?.report_task_id)
                  setDisabledParentDd(true)
                  setDisabledAssginee(true)
                  form.setFieldsValue({
                    parent_id: record?.parent_task_id == null ? 0 : record?.parent_task_id,
                    task_name: record?.task_name,
                    task_assignee_id: record?.task_assignee_id,
                    task_due_date: moment(record?.task_due_date),
                    task_status_id: record?.task_status_id,
                    task_priority_id: record?.task_priority_id,
                    task_desc: record?.task_description,
                    start_date: moment(record?.start_date),
                    // task_type_id: record?.task_type_id.toString(),
                    task_result: record?.task_result,
                    files: files,
                  })
                  fileList = files

                  showModal()
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                disabled={disabled}
                onClick={() => {
                  ModalAntd.confirm({
                    title: 'Confirm deletion',
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>Name</dt>
                          <dd>- {record.task_name}</dd>
                          <dt>Assignee</dt>
                          <dd>- {record.assignee}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: 'Delete',
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: 'Cancel',
                    onOk: async () => {
                      await deleteTask(record?.report_task_id)
                    },
                  })
                }}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  const subColumns = [
    {
      title: t('Corrective Action'),
      dataIndex: 'corrective_action',
      key: 'corrective_action',
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee',
      key: 'assignee',
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
    },
    {
      title: t('Due Date'),
      dataIndex: 'task_due_date',
      key: 'task_due_date',
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: 200,
      render: (text, record, index) => {
        if (record.is_edit == 0) {
          return
        }
        return (
          <Space size='small'>
            <Tooltip title={t('Edit')} style={{ padding: 0 }}>
              <Button
                type='link'
                style={{ padding: 0 }}
                icon={<SettingOutlined />}
                onClick={async () => {
                  setEditingId(record.key)
                  setLabelName(t('ชื่อแผนงาน'))
                  const files = await getFile(record?.report_task_id)
                  setDisabledParentDd(true)
                  setDisabledAssginee(true)
                  form.setFieldsValue({
                    parent_id: record?.parent_task_id == null ? 0 : record?.parent_task_id,
                    task_name: record?.task_name,
                    task_assignee_id: record?.task_assignee_id,
                    task_due_date: moment(record?.task_due_date),
                    task_status_id: record?.task_status_id,
                    task_priority_id: record?.task_priority_id,
                    // task_type_id: record?.task_type_id.toString(),
                    task_desc: record?.task_description,
                    task_result: record?.task_result,
                    start_date: moment(record?.start_date),
                    files: files,
                  })
                  fileList = files

                  showModal()
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')} style={{ padding: 0 }}>
              <Button
                type='link'
                style={{ padding: 0 }}
                icon={<DeleteOutlined />}
                disabled={disabled}
                onClick={() => {
                  // const deletingDataSource = _.find(subTask, { id: record?.id })
                  ModalAntd.confirm({
                    title: 'Confirm deletion',
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>Name</dt>
                          <dd>- {record.task_name}</dd>
                          <dt>Assignee</dt>
                          <dd>- {record.assignee}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: 'Delete',
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: 'Cancel',
                    onOk: async () => {
                      await deleteTask(record?.report_task_id)
                    },
                  })
                }}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  const modalVisible = () => {
    setVisibleModel(false)
  }

  const transformDataSoruceToDropdownParent = () => {
    const tempData = [
      {
        label: t('Main Mitigation Plan'),
        value: 0,
      },
    ]
    let str = 'แผนงานย่อยของ '
    // if(editingId == null){
    //   str = ''
    // }else{
    //   str = 'แผนงานย่อยของ '
    // }
    dataSource.map((item) => {
      tempData.push({
        label: `${str}${item?.corrective_action}`,
        value: item?.key,
        task_type_id: item?.task_type_id,
      })
    })

    return tempData
  }

  const getDefaultDescription = async () => {
    const res = await getDefaultDescriptionApi(reportHeaderId)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })
      return
    }

    setDefaultDescription(res.data)
  }

  const getPiorityDropdown = async () => {
    const resValueListType = await getValueListByTypeCodeApi('TKP')

    if (resValueListType.status === 'error') {
      notification.error({
        message: 'Failed',
        description: resValueListType.message,
      })
      return
    }

    const resValueList = await getValueListApi(resValueListType?.data?.value_list_type_id)

    if (resValueList.status === 'error') {
      notification.error({
        message: 'Failed',
        description: resValueList.message,
      })
      return
    }

    setDropDownPiority(
      _.map(resValueList.data, (item) => {
        return { label: item.name, value: item.id }
      })
    )
  }

  const getStatusDropdown = async () => {
    const resValueListType = await getValueListByTypeCodeApi('TKS')

    if (resValueListType.status === 'error') {
      notification.error({
        message: 'Failed',
        description: resValueListType.message,
      })
      return
    }

    const resValueList = await getValueListApi(resValueListType?.data?.value_list_type_id)

    if (resValueList.status === 'error') {
      notification.error({
        message: 'Failed',
        description: resValueList.message,
      })
      return
    }
    setDropDownStatus(
      _.map(resValueList.data, (item) => {
        return { label: item.name, value: item.id }
      })
    )
  }

  const getFile = async (report_task_id) => {
    // setFileList([])
    // fileList = []
    const filesRes = await getReportAttachmentApi({
      report_header_id: reportHeaderId,
      report_task_id: report_task_id,
      report_attribute_value_id: null,
    })

    const tempData = []

    filesRes?.data.map((item) => {
      tempData.push({
        uid: item?.report_attachment_id,
        name: item?.file_path.substring(item?.file_path.lastIndexOf('/') + 1),
        status: 'done',
        url: `${process.env.REACT_APP_SERVICE_URL}${item.file_path}`,
      })
    })

    fileList = tempData
    // setFileList(tempData)

    return tempData
  }

  const getAllUserDropdown = async () => {
    const res = await getAllUser()

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setAllUser(res.data)
  }

  const transformDropDownAssignee = () => {
    const tempData = []

    allUser.map((item) => {
      tempData.push({
        label: item?.employee.employee_name_th,
        value: item?.user_id,
      })
    })

    return tempData
  }

  const showModal = () => {
    setDropdownParent(transformDataSoruceToDropdownParent())
    setDropDownAssignee(transformDropDownAssignee())
    setVisibleModel(true)
  }

  const setRadioGroup = () => {
    form.setFieldsValue({
      task_type_id: '20',
    })
  }

  const saveBtModal = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisibleModel(false)
      setConfirmLoading(false)
    }, 2000)
  }

  const cancelBtModal = () => {
    setVisibleModel(false)
  }

  const _list = async (arr_report_header_id) => {
    if (taskLoading) return

    setTaskLoading(true)

    const res = await getTaskByParams(arr_report_header_id, false, false, ['TTM', 'TTC'])
    setTaskLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setDataSource(transformDataSoruce(res.data))
  }

  const transformDataSoruce = (data) => {
    const tempDataSource = []
    data.map((item) => {
      if (item.children_task.length > 0) {
        tempDataSource.push({
          key: item?.report_task_id,
          corrective_action: item?.task_name,
          assignee: item?.task_assignee?.employee?.employee_name_th,
          priority: item?.task_priority?.value_list_name,
          task_due_date: item?.task_due_date,
          status: item?.task_status?.value_list_name,
          task_name: item?.task_name,
          report_task_id: item?.report_task_id,
          task_type_id: item?.task_type_id,
          task_status_id: item?.task_status_id,
          task_priority_id: item?.task_priority_id,
          task_assignee_id: item?.task_assignee_id,
          parent_task_id: item?.parent_task_id,
          task_result: item?.task_result,
          task_description: item?.task_description,
          start_date: item?.task_start_date,
          is_edit: item?.is_edit,
          child_task: item.children_task.map((item_children) => {
            return {
              key: item_children?.report_task_id,
              corrective_action: item_children?.task_name,
              assignee: item_children?.task_assignee?.employee?.employee_name_th,
              priority: item_children?.task_priority?.value_list_name,
              task_due_date: item_children?.task_due_date,
              status: item_children?.task_status?.value_list_name,
              task_name: item_children?.task_name,
              report_task_id: item_children?.report_task_id,
              task_type_id: item_children?.task_type_id,
              task_status_id: item_children?.task_status_id,
              task_priority_id: item_children?.task_priority_id,
              task_assignee_id: item_children?.task_assignee_id,
              parent_task_id: item_children?.parent_task_id,
              task_result: item_children?.task_result,
              task_description: item_children?.task_description,
              start_date: item?.task_start_date,
              is_edit: item?.is_edit,
            }
          }),
        })
      } else {
        tempDataSource.push({
          key: item?.report_task_id,
          corrective_action: item?.task_name,
          assignee: item?.task_assignee?.employee?.employee_name_th,
          priority: item?.task_priority?.value_list_name,
          task_due_date: item?.task_due_date,
          status: item?.task_status?.value_list_name,
          task_name: item?.task_name,
          report_task_id: item?.report_task_id,
          task_type_id: item?.task_type_id,
          task_status_id: item?.task_status_id,
          task_priority_id: item?.task_priority_id,
          task_assignee_id: item?.task_assignee_id,
          parent_task_id: item?.parent_task_id,
          task_result: item?.task_result,
          task_description: item?.task_description,
          is_edit: item?.is_edit,
          start_date: item?.task_start_date,
          child_task: [],
        })
      }
    })

    return tempDataSource
  }

  const createTask = async (values) => {
    let parent_id = null
    if (values.parent_id == 0) {
      parent_id = null
    } else {
      parent_id = values.parent_id
    }

    const res = await createTaskApi({
      report_header_id: reportHeaderId,
      parent_task_id: parent_id,
      task_name: values.task_name,
      task_assignee_id: values.task_assignee_id,
      task_due_date: values.task_due_date.format('YYYY-MM-DD'),
      task_type_id: 19,
      task_description: values.task_desc,
      task_status_id: values.task_status_id,
      task_priority_id: values.task_priority_id,
      task_result: values.task_result,
      task_start_date: values.start_date.format('YYYY-MM-DD'),
    })

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    } else {
      if (values.files != null)
        uploadFiles(values.files, reportHeaderId, res?.data?.report_task_id, null)
      notification.success({
        message: 'Success',
        description: res.message,
      })
    }

    _list([reportHeaderId])

    setVisibleModel(false)

    form.resetFields()
  }

  const updateTask = async (id, values) => {
    const res = await updateTaskApi(id, {
      report_header_id: reportHeaderId,
      parent_task_id: values.parent_id == 0 ? null : values.parent_id,
      task_name: values.task_name,
      task_assignee_id: values.task_assignee_id,
      task_due_date: values.task_due_date.format('YYYY-MM-DD'),
      task_type_id: 19,
      task_description: values.task_desc,
      task_status_id: values.task_status_id,
      task_priority_id: values.task_priority_id,
      task_result: values.task_result,
      task_start_date: values.start_date.format('YYYY-MM-DD'),
    })

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    } else {
      const fileRes = await getFile(id)
      let delFileIds = []
      values.files.map((item) => {
        delFileIds.push(item.uid)
      })
      deleteFileNotUse(delFileIds)
      if (values.files != null) {
        uploadFiles(values.files, reportHeaderId, res?.data?.report_task_id, null)
      }

      notification.success({
        message: 'Success',
        description: res.message,
      })
    }

    _list([reportHeaderId])

    setVisibleModel(false)

    form.resetFields()
  }

  const deleteFileNotUse = async (noDelIds) => {
    const delIds = []
    _.map(fileList, (item) => {
      if (noDelIds.includes(item.uid)) {
      } else {
        delIds.push(item.uid)
      }
    })

    if (delIds.length > 0) {
      const res = await deleteReportAttachmentApi(delIds)

      if (res.status === 'error') {
        notification.error({
          message: 'Failed',
          description: res.message,
        })

        return
      }
    }
  }

  const uploadFiles = async (
    files,
    report_header_id,
    report_task_id,
    report_attribute_value_id
  ) => {
    const uploadFile = []
    const oldFile = []

    files.map((item) => {
      if (item?.status == 'done') {
        oldFile.push(item.uid)
      } else {
        uploadFile.push(item.originFileObj)
      }
    })

    if (oldFile.length > 0) deleteFileNotUse(oldFile)

    if (files.length == 0) deleteFileNotUse([])

    if (uploadFile.length > 0) {
      const res = await postReportAttachmentApi(uploadFile, {
        report_header_id: report_header_id,
        report_task_id: report_task_id,
        report_attribute_value_id: report_attribute_value_id,
      })

      if (res.status === 'error') {
        notification.error({
          message: 'Failed',
          description: res.message,
        })
        return
      }
    }
  }

  const deleteTask = async (id) => {
    const fileRes = await getFile(id)
    await deleteFileNotUse([])

    if (fileRes.status === 'error') {
      notification.error({
        message: 'Failed',
        description: fileRes.message,
      })

      return
    } else {
      const res = await deleteTaskApi(id)
      notification.success({
        message: 'Success',
        description: fileRes.message,
      })
    }

    _list([reportHeaderId])
  }

  useAsync(async () => {
    _list([reportHeaderId])
    getDefaultDescription()
    getAllUserDropdown()
    getStatusDropdown()
    getPiorityDropdown()
  }, [])

  return (
    <Styled>
      <Card
        title={'Create Action Plan'}
        titleExtra={
          <Space>
            <Button
              type='primary'
              style={{ background: 'purple', borderColor: 'purple' }}
              disabled={disabled}
              onClick={async () => {
                form.resetFields()
                setDisabledParentDd(true)
                setEditingId(null)
                setDisabledAssginee(false)
                setRadioGroup()
                let dateNow = new Date()
                form.setFieldsValue({
                  parent_id: 0,
                  task_desc: defaultDescription,
                  start_date: moment(
                    `${dateNow.getFullYear()}-${dateNow.getMonth() + 1}-${dateNow.getDate()}`
                  ),
                })
                showModal()
              }}
            >
              {t('Create AP')}
            </Button>
          </Space>
        }
      >
        <TableCorrective
          loading={isLoading}
          correctiveColumn={columns}
          subColumn={subColumns}
          dataSource={dataSource}
          scroll={{ x: 1200 }}
        />
      </Card>
      <Modal
        getContainer={false}
        title='Create Task'
        visible={visibleModel}
        onOk={saveBtModal}
        confirmLoading={confirmLoading}
        onCancel={modalVisible}
        footer={[
          <Button
            loading={saveBtModalLoading}
            key='save'
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            {'Save'}
          </Button>,
        ]}
      >
        <div>
          <Form
            form={form}
            layout='vertical'
            onFinish={async (values) => {
              if (editingId) {
                updateTask(editingId, values)
              } else {
                createTask(values)
              }
            }}
          >
            <Form.Item
              label={'Parent'}
              name='parent_id'
              rules={[
                {
                  required: true,
                  message: t('Please select parent'),
                },
              ]}
            >
              <Select
                disabled={disabledParentDd}
                options={dropDownParent}
                style={{ width: '100%', textAlign: 'center' }}
                onChange={(value) => {
                  // if(value == 0){
                  //   setDisabledRadio(false)
                  // }else{
                  //   setDisabledRadio(true)
                  //   let temp_task_type_id = dropDownParent.filter((item)=>{
                  //     return item.value == value
                  //   })
                  //   form.setFieldsValue({
                  //     task_type_id: temp_task_type_id[0].task_type_id.toString()
                  //   })
                  // }
                }}
              />
            </Form.Item>
            {/* <Form.Item name="task_type_id" visible={true}>
              <Radio.Group disabled={disabledRadio || disabledParentDd ? true : false}>
                <Radio value="20">Corrective Action</Radio>
                <Radio value="19">Mitigation Plan</Radio>
              </Radio.Group>
            </Form.Item> */}
            <Form.Item
              label={labelName}
              name='task_name'
              rules={[
                {
                  required: true,
                  message: t('Please input task name'),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label={'Description'} name='task_desc'>
              <TextArea rows={2} />
            </Form.Item>
            <Form.Item
              name='task_assignee_id'
              label={'Assignee'}
              rules={[
                {
                  required: true,
                  message: t('Please select task assignee name'),
                },
              ]}
            >
              <Select
                disabled={is_riskAnalyst ? false : disabledAssginee}
                options={dropDownAssignee}
                style={{ width: '95%', textAlign: 'center' }}
              />
            </Form.Item>
            <Row>
              <Col span={12}>Start Date</Col>
              <Col span={12}>Due Date</Col>
            </Row>
            <Row>
              <Col span={12} style={{ paddingRight: 2 }}>
                <Form.Item name='start_date'>
                  <DatePicker
                    // disabled={disabledStartDate}
                    style={{ width: '100%', borderRadius: '10px' }}
                    disabledDate={(current) => {
                      return moment().add(-1, 'days') >= current
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='task_due_date'
                  rules={[
                    {
                      required: true,
                      message: t('Please select task due date'),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%', borderRadius: '10px' }}
                    disabledDate={(current) => {
                      return moment().add(-1, 'days') >= current
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={16}>Priority</Col>
              <Col span={8}>Status</Col>
            </Row>
            <Row>
              <Col span={16}>
                <Form.Item
                  name='task_priority_id'
                  rules={[
                    {
                      required: true,
                      message: t('Please select task priority'),
                    },
                  ]}
                >
                  <Select options={dropDownPiority} style={{ width: '95%', textAlign: 'center' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='task_status_id'
                  rules={[
                    {
                      required: true,
                      message: t('Please select task status'),
                    },
                  ]}
                >
                  <Select options={dropDownStatus} style={{ width: '100%', textAlign: 'center' }} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label={t('Result')} name='task_result'>
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item label={t('Attach File')} name='files'>
              <Upload />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </Styled>
  )
}
